<button mat-button>Просто кнопка</button>
<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig">
</aur-mat-table>
